var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnsYoutube = function SvgSnsYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.582 2.186A2.505 2.505 0 0 0 17.814.418C16.254 0 10 0 10 0S3.746 0 2.186.418c-.86.23-1.538.908-1.768 1.768C0 3.746 0 7 0 7s0 3.254.418 4.814c.23.86.908 1.538 1.768 1.768C3.746 14 10 14 10 14s6.254 0 7.814-.418a2.505 2.505 0 0 0 1.768-1.768C20 10.254 20 7 20 7s0-3.254-.418-4.814ZM8 10V4l5.196 3L8 10Z",
    fill: "current"
  })));
};
export default SvgSnsYoutube;